import React from 'react';
import TooltipContent from './tooltip-content';

const tooltipContentType = (<TooltipContent />).type;

export default (props, propName) => {
  if (!props) {
    return new Error('Pass props to tooltip!');
  }
  const childrenProp = props[propName];
  const hasTextProp = !!props.text;
  const children = Array.isArray(childrenProp) ? childrenProp : [childrenProp];
  const initialAccumulator = {
    tooltipContentCount: 0,
    otherCount: 0,
  };
  const childReducer = (acc, child) => {
    if (!child) {
      return acc;
    }
    if (child.type === tooltipContentType) {
      return {
        ...acc,
        tooltipContentCount: acc.tooltipContentCount + 1,
      };
    }
    return {
      ...acc,
      otherCount: acc.otherCount + 1,
    };
  };

  const result = children.reduce(childReducer, initialAccumulator);

  if (result.otherCount === 0) {
    return new Error('Tooltip requires something to put the tooltip on!');
  }

  if (result.otherCount > 1) {
    return new Error('Tooltip requires only one thing to put the tooltip on!');
  }

  if (result.tooltipContentCount > 1) {
    return new Error('Too many TooltipContent elements.');
  }

  if (result.tooltipContentCount === 0 && !hasTextProp) {
    return new Error('Must have content for the tooltip. Include a <TooltipContent> as a child or specify the text prop.');
  }

  return null;
};
